/** @format */

import {withUploadHandler} from 'frontier-utilities';
import React from 'react';

export const FileUploader = withUploadHandler(props => {
    return (
        <div className="design-upload">
            {props.dropping && <div>Dropping</div>}
            {props.uploading && <div>Uploading...</div>}
            {Object.keys(props.fileProgress).map((key, index) => {
                const f = props.fileProgress[key];
                return <span key={index}>{f.totalPercent}%</span>;
            })}
            <button
                className="p-0 m-0 d-flex align-items-center justify-content-start gap-3 color-accent-primary"
                onClick={props.onClickAddFiles}>
                <i className="fa-solid fa-upload"></i>
                <span>Drag artwork or click to upload from your computer</span>
            </button>
        </div>
    );
});
